import request from "../utils/request";

export function listWebTabs() {
    return request({
        url: "/webtabs/list",
        method: "get",
    });
}

export function getWebTab(id) {
    return request({
        url: `/webtabs/${id}`,
        method: "get",
    });
}

export function createWebTab(data) {
    return request({
        url: "/webtabs",
        method: "post",
        data,
    });
}

export function updateWebTab(id, data) {
    return request({
        url: `/webtabs/${id}`,
        method: "put",
        data,
    });
}

export function deleteWebTab(id) {
    return request.delete(`/webtabs/${id}`);
}

export const WEB_TABS_API = {
    listWebTabs,
    getWebTab,
    createWebTab,
    updateWebTab,
    deleteWebTab,
};
